export const businessCurrency = (user?: any, currency?: string) => {
    const language = user?.country === 'New Zealand' ? 'NZD' : "$";
    return language;
};
